/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupOfficeUsersRoutingModule, } from './builder-setup-office-users-routing.module';
import { OfficeUserListTabComponent } from './components/office-user-list-tab/office-user-list-tab.component';
import { OfficeUserListComponent } from './components/office-user-list/office-user-list.component';
import { OfficeUserListBusinessService } from './resources/office-user-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupOfficeUsersRoutingModule,
  ],
  providers: [
    OfficeUserListBusinessService,
  ],
  declarations: [
    OfficeUserListTabComponent,
    OfficeUserListComponent,
  ],
})
export class BuilderSetupOfficeUsersModule {
}
